import { render, staticRenderFns } from "./InternationalFreight.vue?vue&type=template&id=a8a4a15e&scoped=true&"
import script from "./InternationalFreight.vue?vue&type=script&lang=js&"
export * from "./InternationalFreight.vue?vue&type=script&lang=js&"
import style0 from "./InternationalFreight.vue?vue&type=style&index=0&id=a8a4a15e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a4a15e",
  null
  
)

export default component.exports